import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Switch, Route, Link } from 'react-router-dom';

// Importação do Bootstrap
import { Navbar, NavItem, Nav, MenuItem, NavDropdown } from 'react-bootstrap';

//Importo o componente de conteudo
import Globals from '../Miscelania/Globals';
import Overlay from '../Miscelania/Overlay';
import getLocale from '../../i18n/getLocale';

import { BR, GY } from 'country-flag-icons/react/3x2'

import FlightReportRefuelsAdd from '../FlightReportRefuels/FlightReportRefuelsAdd';
import FlightReportRefuelsEdit from '../FlightReportRefuels/FlightReportRefuelsEdit';
import FlightReportRefuelsIndex from '../FlightReportRefuels/FlightReportRefuelsIndex';
import FlightReportRefuelsRequestAdd from '../FlightReportRefuels/FlightReportRefuelsRequestAdd';
import FlightReportRefuelsRequestEdit from '../FlightReportRefuels/FlightReportRefuelsRequestEdit';
import FlightReportRefuelsRequestIndex from '../FlightReportRefuels/FlightReportRefuelsRequestIndex';

const PropTypes = require('prop-types');
class Topo extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      loaded: 0,
      user: JSON.parse(localStorage.getItem("data")).email,
      total: 0,
      total_qpulse: 0,
      total_staff_papers: 0,
      total_schedules: 0,
      total_flight_reports: 0,
      total_trainings: 0,
      total_presence_trainings: 0,
      total_ead_trainings: 0,
      is_online: true,
      menu_sm: false,
      language: false,
      last_online_status: 'working',
    }

    this.loadData = this.loadData.bind(this);
    this.changeMenu = this.changeMenu.bind(this);
    this.promptInstallTrigger = this.promptInstallTrigger.bind(this);
    this.logout = this.logout.bind(this);
    this.changeLanguage = this.changeLanguage.bind(this);

    this.locale = getLocale();
    this.handleAlert = this.handleAlert.bind(this);
    
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  changeMenu(url) {
    this.context.router.history.push(url);
  }

  promptInstallTrigger() {

    this.props.promptInstall();
  }

  logout(e) {
    e.preventDefault();
    localStorage.removeItem("cid");
    this.context.router.history.push('/usuario/login');
  }

  
  componentDidMount () {
    var self = this;

    if (localStorage.getItem("lang") !== null) {
      this.setState({language: localStorage.getItem("lang")})
    } else {
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/usuario/idioma', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.setState({language: responseJson.data.language});
          localStorage.setItem("lang", responseJson.data.language);
        }).catch((error) => {
          console.error(error);
        });
      });
      
    }

    if(navigator.onLine) {
      // self.loadData();
    }
  }

  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/portal/funcionario/pendencias';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          var url_actual = window.location.href;
          var url_staff_qpulse = 'pendencias/qpulse';
          self.setState({total: responseJson.data.total});
          self.setState({total_training_certification_staff_daily: responseJson.data.total_training_certification_staff_daily});
          self.setState({total_qpulse: responseJson.data.total_qpulse});
          self.setState({total_staff_papers: responseJson.data.total_staff_papers});
          self.setState({total_schedules: responseJson.data.total_schedules});
          self.setState({total_flight_reports: responseJson.data.total_flight_reports});
          self.setState({total_trainings: responseJson.data.total_trainings});
          self.setState({total_presence_trainings: responseJson.data.total_presence_trainings});
          self.setState({total_ead_trainings: responseJson.data.total_ead_trainings});
          if(!url_actual.includes(url_staff_qpulse) && responseJson.data.total_qpulse > 0) {
            window.location.replace(config.get('url') + '/pendencias/qpulse');
          }
        }
      }); /* Overlay */
    });
  }

  changeLanguage(e) {
    var current_language = localStorage.getItem("lang");
    var new_language = 'pt-BR';
    if(current_language === 'pt-BR') new_language = 'en-US';
    this.setState({language: new_language});
    localStorage.setItem("lang", new_language);

    var header = this.refs.request_api.header('application/json');
    var self = this;
    var datasave = {
      language: new_language,
    };

    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/usuario/idioma', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        window.location.reload();
      }).catch((error) => {
        console.error(error);
      });
    });  
  }

  render() {
    var self = this;
    return (
      <div>
        <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
        <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
        <section id="top">
          <div className="container">
            <div className="row">
              <div className="col-xs-12 col-md-6" id="top-infs">
                {this.locale.Layout.Topo.bemvindo} {this.state.user}- <Link to={'/usuario/nova/senha'}>{this.locale.Layout.Topo.botaoMinhaConta}</Link>&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;<Link to={'/usuario/login'} onClick={this.logout}>{this.locale.Layout.Topo.botaoSair}</Link>
              </div>
              <div className="col-xs-12 col-md-6 text-right" id="top-infs">
              </div>
            </div>
          </div>
        </section>
        <section id="header">
          <Navbar collapseOnSelect>
            <Navbar.Header>
              <Navbar.Brand>
                <Link to={'/'}><img src={config.get('cdn') + '/images/logo1.png'} style={{width: '100%'}} alt="FUEL" /></Link>
              </Navbar.Brand>
              <Navbar.Toggle />
            </Navbar.Header>
            <Navbar.Collapse>
              <Nav>
                <NavDropdown className="hidden-sm" eventKey={1} title={this.locale.Layout.Topo.menuVoos.Abastecimentos} id="menu-abastecimentos">
                  <MenuItem header>{this.locale.Layout.Topo.menuVoos.Abastecimentos}</MenuItem>
                  <MenuItem href={'/abastecimentos/solicitacoes'} className="menu-links">{this.locale.Layout.Topo.menuVoos.SolicitacoesDeAbastecimentos}</MenuItem>
                  <MenuItem href={'/abastecimento/solicitar'} className="menu-links">{this.locale.Layout.Topo.menuVoos.SolicitarAbastecimento}</MenuItem>
                  <MenuItem divider />
                  <MenuItem href={'/abastecimentos'} className="menu-links">{this.locale.Layout.Topo.menuVoos.ListaDeAbastecimentos}</MenuItem>
                  <MenuItem href={'/abastecimento/cadastrar'} className="menu-links">{this.locale.Layout.Topo.menuVoos.CadastrarAbastecimentoAvulso}</MenuItem>
                </NavDropdown>
              </Nav>
              <Nav className="visible-sm">
                  <MenuItem onClick={() => this.setState({menu_sm: !this.state.menu_sm})} className="menu-links">{!this.state.menu_sm && this.locale.general.abrirMenu} <i className={!this.state.menu_sm ? "fa fa-caret-down" : "fa fa-close" }></i></MenuItem>

                  {this.state.menu_sm &&
                    <NavDropdown eventKey={2} title={this.locale.Layout.Topo.menuVoos.Abastecimentos} id="menu-abastecimentos">
                      <MenuItem header>{this.locale.Layout.Topo.menuVoos.Abastecimentos}</MenuItem>
                      <MenuItem href={'/abastecimentos/solicitacoes'} className="menu-links">{this.locale.Layout.Topo.menuVoos.SolicitacoesDeAbastecimentos}</MenuItem>
                      <MenuItem href={'/abastecimento/solicitar'} className="menu-links">{this.locale.Layout.Topo.menuVoos.SolicitarAbastecimento}</MenuItem>
                      <MenuItem divider />
                      <MenuItem href={'/abastecimentos'} className="menu-links">{this.locale.Layout.Topo.menuVoos.ListaDeAbastecimentos}</MenuItem>
                      <MenuItem href={'/abastecimento/cadastrar'} className="menu-links">{this.locale.Layout.Topo.menuVoos.CadastrarAbastecimentoAvulso}</MenuItem>
                    </NavDropdown>
                  }
              </Nav>
              <Nav pullRight>
                <NavDropdown eventKey={3} title={this.state.language === 'pt-BR' ? <BR className="fa fa-fw" /> : <GY className="fa fa-fw" />} id="menu-treinamento">
                  <MenuItem onClick={this.changeLanguage} className="menu-links">{this.locale.general.mudarLinguagem}</MenuItem>
                </NavDropdown>
              </Nav>
            </Navbar.Collapse>
          </Navbar>
        </section>

        {
          config.get('development') &&
          <section className="development" style={{padding: '20px', background: '#ffcccb', color: 'red', width: '100%', marginBottom: '20px', fontSize: '20px'}}>
            <i className="fa fa fa-warning"></i><span style={{color: 'red'}}> {this.locale.Layout.Topo.atencaoVoceEstaUtilizandoOAmbienteDeHomologacao} </span><i className="fa fa fa-warning"></i>
          </section>
        }
        {
          !this.state.is_online &&
          <section className="development" style={{padding: '20px', background: '#ffcccb', color: 'red', width: '100%', marginBottom: '20px', fontSize: '20px'}}>
            <i className="fa fa fa-warning"></i><span style={{color: 'red'}}> {this.locale.general.semConexao} </span><i className="fa fa fa-warning"></i>
          </section>
        }
        <div>
          <Switch>
            <Route promptInstall={this.promptInstall} path="/abastecimento/cadastrar" render={(props) => <FlightReportRefuelsAdd {...props} promptInstall={this.promptInstall} />} />
            <Route promptInstall={this.promptInstall} path="/abastecimento/solicitar" render={(props) => <FlightReportRefuelsRequestAdd {...props} promptInstall={this.promptInstall} />} />
            <Route promptInstall={this.promptInstall} path="/abastecimento/editar/:id" render={(props) => <FlightReportRefuelsEdit {...props} promptInstall={this.promptInstall} />} />
            <Route promptInstall={this.promptInstall} path="/abastecimento/solicitacao/editar/:id" render={(props) => <FlightReportRefuelsRequestEdit {...props} promptInstall={this.promptInstall} />} />
            <Route promptInstall={this.promptInstall} path="/abastecimentos/solicitacoes" render={(props) => <FlightReportRefuelsRequestIndex {...props} promptInstall={this.promptInstall} />} />
            <Route promptInstall={this.promptInstall} path="/abastecimentos" render={(props) => <FlightReportRefuelsIndex {...props} promptInstall={this.promptInstall} />} />
            <Route promptInstall={this.promptInstall} path="/" render={(props) => <FlightReportRefuelsRequestIndex {...props} promptInstall={this.promptInstall} />} />
          </Switch>
        </div>
      </div>

    );
  }
}

Topo.contextTypes = {
  router: React.PropTypes.object.isRequired
}


export default Topo;



// WEBPACK FOOTER //
// ./src/Components/Layout/Topo.js